// Shared API building blocks (WP0, architecture §7.1, §7.5).
import { z } from 'zod';
import type { Counts } from '../domain.ts';
import type { Settings } from '../settings.ts';
import type { AgentSummary } from './agents.ts';
import type { IntegrationStatus } from './integrations.ts';
import type { BudgetState } from './usage.ts';

/** Cursor-paged list (`?cursor=<opaque>&limit=<1..100>`). */
export interface Page<T> { items: T[]; nextCursor: string | null }

export const PageQuery = z.object({
  cursor: z.string().max(500).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});
export type PageQuery = z.infer<typeof PageQuery>;

export const UuidParam = z.object({ id: z.uuid() });
export type UuidParam = z.infer<typeof UuidParam>;


/** GET /api/bootstrap */
export interface BootstrapResponse {
  version: string;
  settings: Settings;
  agents: AgentSummary[];
  counts: Counts;
  vapidPublicKey: string | null;
  integrations: IntegrationStatus[];
  budget: BudgetState;
  /** The only origin a money link (`freigabe_url`) may have (STZ_ADMIN_ORIGIN, §10.9); null: money links show the host as text. */
  stzAdminOrigin: string | null;
}

/** GET /api/health */
export interface HealthResponse { ok: true; version: string; db: 'ok' }

/** POST /api/presence */
export const PresenceBody = z.object({ visible: z.boolean() });
export type PresenceBody = z.infer<typeof PresenceBody>;
